import type { DocumentReference } from 'firebase/firestore'
import { collection, query, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'

export const collectionRoutes = collection(
  firestore,
  'routes',
)

export function getRoutesQuery(company: DocumentReference) {
  return query(
    collectionRoutes,
    where(
      'company',
      '==',
      company,
    ),
  )
}

export function getRoutesByCities(company: DocumentReference, cities: string[]) {
  return query(
    collectionRoutes,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'city',
      'in',
      cities,
    ),
  )
}
